import {LOG_ROWS_TO_DOWNLOAD} from 'common/constants';
import {downloadTextFile} from 'common/downloadFile';
import React, {ErrorInfo} from 'react';
import safeStringify from 'safe-stringify';

class ErrorBoundary extends React.Component<any, any> {
   constructor(props: any) {
      super(props);
      this.state = {hasError: false};
   }

   static getDerivedStateFromError(error: ErrorInfo) {
      console.debug(error);
      console.error(error.toString());
      const logs = console.logs.slice(-LOG_ROWS_TO_DOWNLOAD);
      const logsText = safeStringify(logs);
      if (process.env.NODE_ENV === 'production') {
         downloadTextFile(logsText, `${Date.now()}_coviant-diplomat-crash-report.log`);
      }
      return {hasError: true};
   }

   render() {
      if (this.state.hasError) {
         return <h1>Something went wrong. Please reload the page. Crash report downloaded.</h1>;
      }

      return this.props.children;
   }
}

export default ErrorBoundary;
